import React, { useEffect } from "react";
import { NavMenu } from "@shopify/app-bridge-react";

export default function AppNavMenu() {
  useEffect(() => {
    console.log("[NavMenu] Component mounted");
  }, []);

  return (
    <NavMenu>
      <a href="/" rel="home">Home</a>
      <a href="/places">Places</a>
      <a href="/analytics">Analytics</a>
      <a href="/themes">Themes</a>
      <a href="/seo-templates">SEO Templates</a>
      <a href="/settings">Settings</a>
    </NavMenu>
  );
}

